
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { InventoryBin, InventoryUiClient } from '../../../../backend/backendapi';
import { handleError, initClient } from '../../../../../api';
import TabGeneral from './TabGeneral';
import TabButton from '../../../../util/TabButton';

@Component({
  name: 'BinEditModal',
  components: {
    TabButton,
    TabGeneral,
  },
})
export default class BinEditModal extends Vue {
  bin: InventoryBin | null = null;
  edit: boolean = false;
  tab: 'general' = 'general';

  //api
  private readonly service = initClient(InventoryUiClient);

  public open(bin: InventoryBin, edit: boolean): void {
    this.bin = bin;
    this.edit = edit;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private save(): void {
    if (!this.bin) {
      return;
    }

    let savePromise: Promise<InventoryBin>;
    if (!this.edit) {
      savePromise = this.service.addBin(this.bin);
    } else {
      savePromise = this.service.updateBin(this.bin);
    }

    savePromise
        .then(_ => {
          this.$toasted.info(this.$t('txtSaved').toString());
          this.$emit('saved');
          this.dismiss();
          this.edit = false;
        })
        .catch(e => handleError(this.$toasted, this.$i18n, e));
  }
}
